import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import styled from "styled-components";
import CompanyMemberCourseStatusTable from "./CompanyMemberCourseStatusTable";
// import UserRolesContent from "./UserRolesContent";
import CompanyMemberRolesTable from "./CompanyMemberRolesTable";
import AddDeleteUserCompany from "./AddDeleteUserCompany";
import CourseRegistrationCompany from "./CourseRegistrationCompany";

import SupervisedUserCircleRoundedIcon from "@mui/icons-material/SupervisedUserCircleRounded";
import AddCircleRoundedIcon from "@mui/icons-material/AddCircleRounded";
import HowToRegRoundedIcon from "@mui/icons-material/HowToRegRounded";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import TeamUserTransfer from "./TeamUserTransfer";
import TransferWithinAStationIcon from "@mui/icons-material/TransferWithinAStation";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import ReceiptIcon from "@mui/icons-material/Receipt";

import firebaseApp from "../firebase";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import TeamsBasket from "../pages/teamsBasket";
import TeamsOrder from "./TeamsOrder";
const auth = getAuth();

function CompanyMembers() {
  const { state } = useLocation();

  const [user, setUser] = useState(JSON.parse(localStorage.getItem("user")));
  // const [teamId, setTeamId] = useState();
  const [teamMembers, setteamMembers] = useState(null);
  const [teamMemberEmail, setTeamMemberEmail] = useState(null);
  const [clickStatus, setClickStatus] = useState(null);

  const [userRoleMenuColor, setUserRoleMenuColor] = useState("transparent");
  const [userAddDeleteMenuColor, setUserAddDeleteMenuColor] =  useState("transparent");
  const [userRegisterationMenuColor, setUserRegisterationMenuColor] = useState("transparent");
  const [userStatusMenuColor, setUserStatusMenuColor] = useState("transparent");
  const [teamCartMenuColor, setTeamCartMenuColor] = useState("transparent");
  const [teamOrderMenuColor, setTeamOrderMenuColor] = useState("transparent");

  const [courseInfo, setCourseInfo] = useState(null);

  const [currentUserRole, setCurrentUserRole] = useState(null);
  const [userTransferMenuColor, setUserTransferMenuColor] =
    useState("transparent");

  const [teamCartContent, setTeamCartContent] = useState(
    JSON.parse(localStorage.getItem("teamCart"))
  );

  const [teamId, setTeamId] = useState(null);
  const [numberOfCartItems, setNumberOfCartItems] = useState(0);

  const isEmail = (email) => {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (email.match(re)) return true;
    else return false;
  };

  const isEmpty = (string) => {
    if (string.trim() === "") return true;
    else return false;
  };

  useEffect(() => {
    if (!currentUserRole) return;

    if (currentUserRole === "owner" || currentUserRole === "admin") {
      setClickStatus("registration");
      setUserRegisterationMenuColor("rgba(95, 176, 95, 0.5)");
    } else {
      setClickStatus("roles");
      setUserRoleMenuColor("rgba(95, 176, 95, 0.5)");
    }
  }, [currentUserRole]);

  const resetNumberOfTeamCartItems = (teamId) => {
    const db = firebaseApp.firestore();
    // console.log("Team IDID:", teamId);
    db.collection("TeamsCart")
      .where("teamId", "==", teamId)
      .get()
      .then((data) => {
        if (data.docs.length > 0) {
          db.collection("TeamsCart")
            .doc(data.docs[0].id)
            .collection("Cart")
            .orderBy("createdAt", "desc")
            .onSnapshot((snapshot) => {
              const items = [];
              snapshot.forEach((doc) => {
                const newData = doc.data();
                newData.cartId = data.docs[0].id;
                newData.itemId = doc.id;
                items.push(newData);
              });
              setNumberOfCartItems(snapshot.size);
              localStorage.setItem("teamCart", JSON.stringify(items));
            });
        } else {
          setNumberOfCartItems(0);
        }
      });
    // .doc(userEmail)
    // .collection("Notes")
    // .where("seen", "==", false)

    // .onSnapshot((snapshot) => {
    //   setNumberOfNotes(snapshot.size);
    // });
  };

  const resetCompanyTeamMembers = (teamId) => {
    axios
      .post("/returnCompanyTeamMembers", {
        teamId: teamId,
      })
      .then((data) => {
        // console.log(data.data);
        setteamMembers(data.data);
        axios
          .post("/returnUserRole", {
            userEmail: user.email,
            teamId: teamId,
          })
          .then((userRole) => {
            // console.log("User role is importsnt:", userRole);
            setCurrentUserRole(userRole.data.role);
          });
      });
  };

  useEffect(() => {
    if (state?.teamId) {
      setTeamId(state?.teamId);
      resetCompanyTeamMembers(state.teamId);
    }
  }, [state?.teamId, state?.forceUpdate]);

  useEffect(() => {
    axios.get("/extractCourses").then((data) => {
      setCourseInfo(data.data);
    });
  }, []);

  useEffect(() => {
    if (teamId) {
      onAuthStateChanged(auth, (userm) => {
        if (userm) {
          resetNumberOfTeamCartItems(teamId);
        }
      });
    }
  }, [teamId]);

  const onClickUserRole = () => {
    setClickStatus("roles");
    setUserRoleMenuColor("rgba(95, 176, 95, 0.5)");
    setUserAddDeleteMenuColor("transparent");
    setUserRegisterationMenuColor("transparent");
    setUserStatusMenuColor("transparent");
    setUserTransferMenuColor("transparent");
    setTeamCartMenuColor("transparent");
    setTeamOrderMenuColor("transparent");
  };

  const onClickAddDeleteUser = () => {
    setClickStatus("add");
    setUserRoleMenuColor("transparent");
    setUserAddDeleteMenuColor("rgba(95, 176, 95, 0.5)");
    setUserRegisterationMenuColor("transparent");
    setUserStatusMenuColor("transparent");
    setUserTransferMenuColor("transparent");
    setTeamCartMenuColor("transparent");
    setTeamOrderMenuColor("transparent");
  };

  const onClickUserRegisteration = () => {
    setClickStatus("registration");
    setUserRoleMenuColor("transparent");
    setUserAddDeleteMenuColor("transparent");
    setUserRegisterationMenuColor("rgba(95, 176, 95, 0.5)");
    setUserStatusMenuColor("transparent");
    setUserTransferMenuColor("transparent");
    setTeamCartMenuColor("transparent");
    setTeamOrderMenuColor("transparent");
  };

  const onClickCourseStatus = () => {
    setClickStatus("status");
    setUserRoleMenuColor("transparent");
    setUserAddDeleteMenuColor("transparent");
    setUserRegisterationMenuColor("transparent");
    setUserStatusMenuColor("rgba(95, 176, 95, 0.5)");
    setUserTransferMenuColor("transparent");
    setTeamCartMenuColor("transparent");
    setTeamOrderMenuColor("transparent");
  };

  const onClickUserTransfer = () => {
    setClickStatus("transfer");
    setUserRoleMenuColor("transparent");
    setUserAddDeleteMenuColor("transparent");
    setUserRegisterationMenuColor("transparent");
    setUserStatusMenuColor("transparent");
    setUserTransferMenuColor("rgba(95, 176, 95, 0.5)");
    setTeamCartMenuColor("transparent");
    setTeamOrderMenuColor("transparent");
  };

  const onClickTeamCart = () => {
    setClickStatus("cart");
    setUserRoleMenuColor("transparent");
    setUserAddDeleteMenuColor("transparent");
    setUserRegisterationMenuColor("transparent");
    setUserStatusMenuColor("transparent");
    setUserTransferMenuColor("transparent");
    setTeamCartMenuColor("rgba(95, 176, 95, 0.5)");
    setTeamOrderMenuColor("transparent");
  };

  const onClickTeamOrder = () => {
    setClickStatus("order");
    setUserRoleMenuColor("transparent");
    setUserAddDeleteMenuColor("transparent");
    setUserRegisterationMenuColor("transparent");
    setUserStatusMenuColor("transparent");
    setUserTransferMenuColor("transparent");
    setTeamCartMenuColor("transparent");
    setTeamOrderMenuColor("rgba(95, 176, 95, 0.5)");
  };

  return (
    <Container>
      <LeftSideManu>
        <CompanyName>{state.teamName}</CompanyName>
        {(currentUserRole === "owner" || currentUserRole === "admin") &&
          <div>
            <CourseRegistration
              onClick={() => onClickUserRegisteration()}
              style={{ backgroundColor: userRegisterationMenuColor }}>
              <HowToRegRoundedIcon style={{ marginRight: "5px" }} />
              Course Registration
            </CourseRegistration>
            <CourseStatus
              onClick={() => onClickCourseStatus()}
              style={{ backgroundColor: userStatusMenuColor }}>
              <AssignmentTurnedInIcon style={{ marginRight: "5px" }} />
              Course Status
            </CourseStatus>
            <UserTransfer
              onClick={() => onClickUserTransfer()}
              style={{ backgroundColor: userTransferMenuColor }}>
              <TransferWithinAStationIcon style={{ marginRight: "5px" }} />
              User Transfer
            </UserTransfer>
          </div>
        }
        {(currentUserRole === "owner" || currentUserRole === "admin") &&
          <div>
            <TeamCart
              onClick={() => onClickTeamCart()}
              style={{ backgroundColor: teamCartMenuColor }}>
              <CartContainer>
                <ShoppingCartIcon style={{ marginRight: "5px" }} /> Team Cart
                {numberOfCartItems > 0 &&
                  <CartCount>
                    <CartNum>{numberOfCartItems}</CartNum>
                  </CartCount>
                }
              </CartContainer>
            </TeamCart>
            <TeamOrder
              onClick={() => onClickTeamOrder()}
              style={{ backgroundColor: teamOrderMenuColor }}>
              <ReceiptIcon style={{ marginRight: "5px" }} /> Team Order
            </TeamOrder>
          </div>
        }


        <UserRoles
          onClick={() => onClickUserRole()}
          style={{ backgroundColor: userRoleMenuColor }}>
          <SupervisedUserCircleRoundedIcon style={{ marginRight: "5px" }} />
          User Roles
        </UserRoles>

        {currentUserRole === "owner" &&
          <AddDeleteUsers
            onClick={() => onClickAddDeleteUser()}
            style={{ backgroundColor: userAddDeleteMenuColor }}>
            <AddCircleRoundedIcon style={{ marginRight: "5px" }} />
            Add/Delete Users
          </AddDeleteUsers>
        }
        
      </LeftSideManu>
      <LeftSideMenuContent>
        {(clickStatus && teamMembers && teamMembers?.length !== 0 && currentUserRole) && 
          clickStatus === "roles" ? (
            <UserRolesContent>
              <CompanyMemberRolesTable
                data={teamMembers}
                role={currentUserRole}
              />
            </UserRolesContent>
          ) : clickStatus === "add" ? (
            <AddDeleteUsersContent>
              <AddDeleteUserCompany
                data={teamMembers}
                resetTeamMember={resetCompanyTeamMembers}
                teamIdProp={state?.teamId}
                role={currentUserRole}
              />
            </AddDeleteUsersContent>
          ) : clickStatus === "registration" ? (
            <CourseRegistrationContent>
              <CourseRegistrationCompany
                data={teamMembers}
                teamIdProp={state?.teamId}
                courseInformation={courseInfo}
                onClickResetItemNumber={resetNumberOfTeamCartItems}
              />
            </CourseRegistrationContent>
          ) : clickStatus === "status" ? (
            <CourseStatusContent>
              <CompanyMemberCourseStatusTable data={teamMembers} />
            </CourseStatusContent>
          ) : clickStatus === "transfer" ? (
            <UserTransferContent>
              <TeamUserTransfer
                teamUsers={teamMembers}
                currentTeamId={state?.teamId}
                allTeams={state?.allTeamsID}
              />
            </UserTransferContent>
          ) : clickStatus === "cart" ? (
            <TeamCartItemHolder>
              <TeamsBasket
                currentTeamId={state?.teamId}
                onClickResetItemNumber={resetNumberOfTeamCartItems}
                cartItemNum={numberOfCartItems}
                teamName={state?.teamName}
              />
            </TeamCartItemHolder>
          ) : (
            <TeamOrderItemHolder>
              <TeamsOrder currentTeamId={state?.teamId} />
            </TeamOrderItemHolder>
          )
        }
      </LeftSideMenuContent>
    </Container>
  );
}

export default CompanyMembers;

const Container = styled.div`
  /* padding: 25px; */
  box-sizing: border-box;
  padding: 70px 0px 0px 0px;
  display: grid;
  grid-template-columns: 250px auto;
  height: 100%;
`;

const LeftSideManu = styled.div`
  /* padding: 10px; */
  /* position: fixed; */
  box-shadow: -6px 8px 18px 1px black;
  width: 250px;
  height: 100%;
`;
const LeftSideMenuContent = styled.div`
  /* border-left: 1px solid; */
  height: 100%;
`;

const UserRoles = styled.div`
  display: flex;
  align-items: center;

  padding: 15px 5px 15px 20px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  &:hover {
    color: black;
    background-color: rgb(95, 176, 95, 0.5) !important;
  }
`;
const AddDeleteUsers = styled.div`
  display: flex;
  align-items: center;
  padding: 15px 5px 15px 20px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  &:hover {
    color: black;
    background-color: rgb(95, 176, 95, 0.5) !important;
  }
`;
const CourseRegistration = styled.div`
  display: flex;
  align-items: center;
  padding: 15px 5px 15px 20px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  &:hover {
    color: black;
    background-color: rgb(95, 176, 95, 0.5) !important;
  }
`;
const CourseStatus = styled.div`
  display: flex;
  align-items: center;
  padding: 15px 5px 15px 20px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  &:hover {
    color: black;
    background-color: rgb(95, 176, 95, 0.5) !important;
  }
`;

const UserTransfer = styled.div`
  display: flex;
  align-items: center;
  padding: 15px 5px 15px 20px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  &:hover {
    color: black;
    background-color: rgb(95, 176, 95, 0.5) !important;
  }
`;

const UserRolesContent = styled.div``;
const AddDeleteUsersContent = styled.div``;
const CourseRegistrationContent = styled.div``;
const CourseStatusContent = styled.div``;
const UserTransferContent = styled.div``;
const TeamCartItemHolder = styled.div``;
const TeamOrderItemHolder = styled.div``;
const CompanyName = styled.div`
  display: flex;
  align-items: center;
  background-color: rgb(95, 176, 95, 1) !important;

  padding: 15px 5px 15px 20px;
  cursor: default;
  font-weight: 600;
  font-size: 18px;
  color: lightgray;
  /* cursor: pointer;
  transition: all 0.2s ease-in-out;
  &:hover {
    color: black;
    background-color: rgb(95, 176, 95, 0.5) !important;
  } */
`;

const TeamCart = styled.div`
  display: flex;
  align-items: center;

  padding: 15px 5px 15px 20px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  &:hover {
    color: black;
    background-color: rgb(95, 176, 95, 0.5) !important;
  }
`;

const CartCount = styled.div`
  position: absolute;
  padding: 4px;
  display: flex;
  justify-content: center;
  align-content: center;
  /* background-color: #09323b; */
  background-color: #ff6275;
  color: white;
  top: -9px;
  /* right: 8px; */
  right: -20px;
  /* width: 15px;
  height: 15px; */
  /* border-radius: 50%; */
  border-radius: 50px;
  font-weight: 600;
  font-size: 10px;
  /* border: 2px solid #f2f2f2; */
  /* border: 2px solid #09323b; */
  border: 2px solid white;

  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.3);
`;

const CartNum = styled.p`
  white-space: nowrap;
  margin: 0px;
  padding: 0px;
  line-height: 6px;
`;

const CartContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const TeamOrder = styled.div`
  display: flex;
  align-items: center;

  padding: 15px 5px 15px 20px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  &:hover {
    color: black;
    background-color: rgb(95, 176, 95, 0.5) !important;
  }
`;